<div class="disable-select" [ngClass]="{'on-home': isHomePage && !isMobile, '_desktop-nav-bar': !isTablet, 'nav-bar': isTablet }">
  <!-- mobile -->
  <div class="_mobile-nav">
    <button mat-icon-button class="back-to-menu-button" (click)="returnToMenu()" *ngIf="isCheckoutPage">
      <mat-icon>menu_book</mat-icon>
    </button>

    <div class="_logo" *ngIf="tenant.Branding.LogoImageUrl">
      <a style="display: flex; align-items: center;" (click)="navigateHome($event)" href="{{ this.navigatorService.generateHomePath() }}">
        <img style="max-width: 100%" [src]="tenant.Branding.LogoImageUrl" draggable="false" id="brandLogo">
      </a>
    </div>

    <div class="_feedback" [class._feedback-tablet]="isTablet && !isMobile">
      <button mat-icon-button (click)="feedback(feedbackModalContent)">
        <span class="material-symbols-outlined">feedback</span>
      </button>
    </div>
    <ng-container *ngTemplateOutlet="userContainer"></ng-container>
  </div>

  <!-- desktop -->
  <div class="_desktop-nav">
    @if (shouldShowSite()) {
      <div class="_desktop-nav-details-sitename">
        <div class="_sitename">
          <span class="text-info-label">{{ occasionText }} from</span>
          <span class="_sitename-current" (click)="confirmChangeStore(switchStoreModal)">{{ currentSite.Name }}</span>
        </div>

        @if (shouldShowWantedTime()) {
          <div class="order-wanted-details">
            <span class="text-info-label">at</span>
            <span class="wanted-time" (click)="openWantedTimeModal(confirmWantedTime)">{{ basketWantedTime }}</span>
          </div>
        }
      </div>
    }

    @if (tenant.Branding.LogoImageUrl) {
      <div class="_desktop-nav-logo-wrapper">
        <a class="_desktop-nav-logo disable-select" (click)="navigateHome($event)" href="/">
          <img class="_desktop-nav-logo-image" [src]="tenant.Branding.LogoImageUrl" draggable="false" id="logImage">
        </a>
      </div>
    }

    <div class="_desktop-nav-details">
      <div class="_desktop-nav-details-feedback" (click)="feedback(feedbackModalContent)">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 15.7167H14.3667C13.7 15.7167 13.0667 15.975 12.6 16.4417L11.175 17.85C10.525 18.4917 9.46666 18.4917 8.81666 17.85L7.39166 16.4417C6.925 15.975 6.28333 15.7167 5.625 15.7167H5C3.61667 15.7167 2.5 14.6083 2.5 13.2417V4.14998C2.5 2.78332 3.61667 1.67501 5 1.67501H15C16.3833 1.67501 17.5 2.78332 17.5 4.14998V13.2417C17.5 14.6 16.3833 15.7167 15 15.7167Z" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M10.2333 12.4667C10.1083 12.5084 9.9 12.5084 9.76667 12.4667C8.68333 12.0917 6.25 10.55 6.25 7.92501C6.25 6.76668 7.18333 5.83333 8.33333 5.83333C9.01667 5.83333 9.61667 6.15833 10 6.66667C10.3833 6.15833 10.9833 5.83333 11.6667 5.83333C12.8167 5.83333 13.75 6.76668 13.75 7.92501C13.7417 10.55 11.3167 12.0917 10.2333 12.4667Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>

        <span>Feedback</span>
      </div>

      <div class="_desktop-nav-details-usermenu" [ngClass]="{'menu-left': !shouldShowBasket()}">
        <ng-container *ngTemplateOutlet="userContainer"></ng-container>

        @if (shouldShowBasket()) {
          <div class="_nav-details-basket" (click)="openBasket()">
            @if (currentBasketCount > 0) {
              <span matBadge="*" class="material-symbols-outlined" (click)="toggleBasket()">local_mall</span>
              <div class="_nav-details-basket-info">
                <span class="_cart-total-label-placeholder">{{ currentBasketCount }}</span>
                <span class="_cart-total-label"[@valueAnimation]="currentBasketCount">{{ currentBasketCount }}</span>
                <span>{{ currentBasketCount > 1 ? 'items' : 'item' }} in basket</span>
              </div>
              <span>{{ currentBasketAmount | currency : 'GBP' }}</span>
            } @else {
              <span class="material-symbols-outlined" (click)="toggleBasket()">local_mall</span>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>

<ng-template #userContainer>
  <div [class.user-dropdown]="isTablet">
    @if (currentUser) {
      @if (isMobile) {
        <button class="user-dropdown-button" mat-icon-button [mat-menu-trigger-for]="userDetailsMenu">
          <span class="material-symbols-outlined"> account_circle </span>
        </button>
      } @else if (isTablet) {
        <button class="user-dropdown-button" mat-flat-button [mat-menu-trigger-for]="userDetailsMenu" (menuOpened)="onMenuOpened(vibes)" #vibes>
          <div class="flex-row no-wrap user-dropdown-button-inner-container" style="align-items: center;">
            <span class="material-symbols-outlined" style="margin-right: 10px;"> account_circle </span>
            <span>{{ currentUser.FirstName + ' ' + currentUser.LastName }}</span>
          </div>
        </button>
      } @else {
        <div class="desktop-user-dropdown-button" mat-icon-button [mat-menu-trigger-for]="userDetailsMenu">
          <span class="material-symbols-outlined"> account_circle</span>
          <span class="user-info">{{ currentUser.FirstName }} {{ currentUser.LastName }}</span>
        </div>
      }

      <mat-menu classList="user-menu-dropdown" #userDetailsMenu="matMenu">
        <mat-nav-list class="user-menu-dropdown-list" style="padding-top: 0;">
          <a mat-list-item [routerLink]="['/profile']" [queryParams]="{view: 'account'}" [state]="{ returnUrl: router.url }" *ngIf="!isProfilePage">
            <div class="flex-row no-wrap user-menu-dropdown-list-inner-container">
              <p class="dropdown-Item-p">My Profile</p>
            </div>
          </a>

          <a mat-list-item [routerLink]="['/profile']" [queryParams]="{view: 'orders'}" *ngIf="!isProfilePage">
            <div class="flex-row no-wrap user-menu-dropdown-list-inner-container">
              <p class="dropdown-Item-p">My Orders</p>
            </div>
          </a>

          <a mat-list-item [routerLink]="['/profile']" [queryParams]="{view: 'address'}" *ngIf="!isProfilePage">
            <div class="flex-row no-wrap user-menu-dropdown-list-inner-container">
              <p class="dropdown-Item-p">My Addresses</p>
            </div>
          </a>

          <a mat-list-item [routerLink]="['/profile']" [queryParams]="{view: 'loyalty'}" *ngIf="!isProfilePage && !tenant.SuppressLoyalty">
            <div class="flex-row no-wrap user-menu-dropdown-list-inner-container">
              <p class="dropdown-Item-p">Loyalty Info</p>
            </div>
          </a>

          <a mat-list-item (click)="returnToMenu()" *ngIf="currentBasket && !isMenuPage">
            <div class="flex-row no-wrap user-menu-dropdown-list-inner-container">
              <p class="dropdown-Item-p">Menu</p>
            </div>
          </a>

          <a mat-list-item [routerLink]="['/']" *ngIf="!isHomePage">
            <div class="flex-row no-wrap user-menu-dropdown-list-inner-container">
              <p class="dropdown-Item-p">Home</p>
            </div>
          </a>

          <a mat-list-item (click)="switchPaymentProvider()" *ngIf="isCheckoutPage && showProviderSwapButton">
            <div class="flex-row no-wrap user-menu-dropdown-list-inner-container">
              <p class="dropdown-Item-p">Switch to {{ paymentProviderInverse }}</p>
            </div>
          </a>

          <mat-divider></mat-divider>

          <a mat-list-item (click)="logOut()">
            <div class="flex-row no-wrap user-menu-dropdown-list-inner-container">
              <p class="dropdown-Item-p">Logout</p>
              <mat-icon class="mobile-menu-list icon">logout</mat-icon>
            </div>
          </a>
        </mat-nav-list>
      </mat-menu>
    } @else {
      @if (isTablet) {
        <button mat-icon-button (click)="login()">
          <span class="login-button material-symbols-outlined">
            person
          </span>
        </button>
      } @else {
        <div class="login-button">
          <span class="material-symbols-outlined">login</span>
          <span (click)="login()" tabindex="0">Sign In / Register</span>
        </div>
      }
    }
  </div>
</ng-template>

<ng-template #basketModalContent>
  <basket-component [showCheckout]="true"
                    style="height: 100%"
                    (allDone)="toggleBasket()"></basket-component>
</ng-template>

<ng-template #switchStoreModal>
  <div class="modal-header nav disable-select">
    <h4 class="modal-title nav">Warning</h4>

    <mat-icon (click)="closeModalById('confirmSwitchStore')">close</mat-icon>
  </div>

  <div class="modal-body nav disable-select">
    <p> You've currently got items in your basket. Please be aware that these items are tied to this store.</p>
  </div>

  <div class="modal-footer nav disable-select">
    <button type="button" class="modal-button-light nav button-action-2" (click)="closeModalById('confirmSwitchStore')">Cancel</button>
    <button type="button" class="modal-button-light nav button-action-1" (click)="switchStore()">Change</button>
  </div>
</ng-template>

<ng-template #feedbackModalContent>
  <feedback-component [userId]="currentUser?.Id" (close)="closeModalById('feedbackForm')"></feedback-component>
</ng-template>

<ng-template #confirmWantedTime>
  <app-wanted-time-picker [basket]="currentBasket" [site]="currentSite"></app-wanted-time-picker>
</ng-template>
